module.exports = __webpack_public_path__ + "assets/img/modal_close.74198e92.svg";